import { DashboardApi, TypeApi } from 'Services';
import { toast } from 'react-toastify';
import { ErrorToast, SuccessToast } from 'Themes/ScufStyledComponents';
import { useHistory } from 'react-router-dom';
import { substract,substractStartDayCurrently, today  } from '../../../../Utils/MomentHelpers'

const useDetailsDownload = () => {
  const history = useHistory();

  const downloadTableData = async ({
    siteId = '',
    startDate = new Date(),
    endDate = new Date(),
    includeChildSites = true,
    tableId = '',
    selectedRow = [],
    language = 'en-US',
    reportingDays = 0,
    tableParams = {},
    applicationName = '',
    packagesNames = '',
    exportParameters = {},
    columns = [],
    setIsAvailableExportButton = () => {},
    t = (l) => l
  }) => {
    setIsAvailableExportButton(false)
    const { batteryPercentage, cycleCountAbove, agingMonths, deviceType, cycleCount, cycleCountTop, minimumBatteryPercentage, agingMonthsTop, month, orgId,dockingTime ,harddockingTime, hoursOfUsePerDay,minHours } = exportParameters
    const { query, includeChildren, sort, directionSort, sites } = tableParams
    const direction = directionSort === undefined ? '' : (directionSort === 'ASC' || directionSort == 1) ? 1 : -1;
        const params = {
      query: query || '',
      includeChildren,
      sort: sort || '',
      directionSort: direction,
      chartName: chartNameExport(tableId),
      lastUpdated: lastUpdatedBatteries(tableId, reportingDays),
      language,
      applicationName: applicationName || packagesNames[0]?.value,
      batteryPercentage: batteryPercentage,
      cycleCountAbove:cycleCountAbove,
      agingMonths:agingMonths,
      deviceType:deviceType,
      cycleCountTop:cycleCountTop,
      cycleCount: cycleCount,
      minimumBatteryPercentage: minimumBatteryPercentage,
      month: month,
      orgId: orgId,
      dockingTime: dockingTime,
      agingMonthsTop: agingMonthsTop,
      dockingTime: harddockingTime,
      hoursOfUsePerDay: hoursOfUsePerDay,
      minHours: minHours,
    };
    const payload = {
      columns: columns,
      siteList: selectedRow.length > 0 ? selectedRow.map(row => row.details?.orgUnitId).filter(orgUnitId => orgUnitId !== undefined) : sites,
      serialNumberList: selectedRow.length > 0 ? selectedRow.map(value => value.SerialNumber).filter(serialNumber => serialNumber !== undefined) : []
    }
    let ok;
    const tableIdsWithPayload = [
      'notReportingBatteries',
      'newBatteriesList',
      'batteryAgeList',
      'batteriesAbove',
      'batteriesBelow',
      'batteryListLowHealth',
      'batteryList',
      'offlineDevicesByModelModal',
      'offlineDevicesBySiteModal',
      'devicesBySiteModal',
      'typesOfModelsModal',
    ];
    const payloadBlank = {
      siteList: '',
      serialNumberList:  '',
      columns: columns
    };
    if (tableIdsWithPayload.includes(tableId)) {
      ({ ok } = await DashboardApi.getExportCVSFile(siteId, payloadBlank, params, startDate, endDate));
      } else {
      ({ ok } = await DashboardApi.getExportCVSFile(siteId, payload, params, startDate, endDate));
    }

    setIsAvailableExportButton(true)
    if (ok) {
      const path = '/reports/downloads';
      toast(<SuccessToast message={t('ExportToastSuccess')} detailsClick={() => history.push(path)} detailsText={t('ExportTextDetails')} />);
    }
    else {
      toast(<ErrorToast message={t('ExportToastError')} />);
    }
  }

  const chartNameExport = (tableId) => {
    if (tableId.startsWith('DeviceByUsageLevels-')) {
      return 'DEVICE_BY_USAGELEVEL_SITEWISE';
    } 
    else {
      switch (tableId) {
      case 'totalBatteriesCard':
        return 'ONBOARDED_BATTERIES'
      case 'notReportingBatteries':
        return 'BATTERIES_NOT_REPORTING_30_DAYS'
      case 'deletedBatteries':
        return 'DELETE_BATTERIES_STILL_REPORTING'
      case 'lostAndFoundCard':
        return 'LOST_FOUND_DEVICES'
      case 'applicationDisruptionsCard':
        return 'DISRUPTION_EVENT'
      case 'applicationDisruptionsByAppCard':
        return 'APPLICATION_DISRUPTIONS_BY_APP'
      case 'batteryDischargeRateDetails':
        return 'BATTERY_DISCHARGE'
      case 'expectedRuntimeDetails':
        return 'BATTERY_EXPECTED_DURATION'
      case 'devicesBySiteModal':
        return 'DEVICE_BY_SITE'
      case 'offlineDevicesByModelModal':
        return 'DEVICE_OFFLINE_MODEL'
      case 'typesOfModelsModal':
        return 'DEVICE_MODEL'
      case 'newBatteriesList':
        return 'NEW_BATTERIES_IN_THE_CURRENT_MONTH'
      case 'batteryListLowHealth':
        return 'BATTERIES_WITH_LOW_HEALTH'
      case 'batteryList':
        return 'BATTERIES_WITH_CYCLES'
      case 'batteryAgeList':
        return 'BATTERIES_WITH_AGING'
      case 'offlineDevicesBySiteModal':
        return 'DEVICE_OFFLINE_SITE'
      case 'printersFirmwareModal':
        return 'PRINTERS_WITH_FIRMWARE'
      case 'batteriesAbove':
        return 'BATTERIES_REPLACE_SOON'
      case 'batteriesBelow':
        return 'BATTERIES_REPLACE_NOW'
      case 'deviceUsageLevels':
        return 'DEVICE_BY_USAGELEVEL'
      case 'deviceHardUsageLevels':
        return 'DEVICES_WITH_DAILY_HOURS_USE'
      case 'Devices with 8+ hours of use per day':
        return 'DEVICES_WITH_DAILY_HOURS_USE_DETAILS'
      default:
        return null;
    }
  }
}
  const lastUpdatedBatteries = (tableId, reportingDays) => {
    let lastUpdated
    switch (tableId) {
      case 'notReportingBatteries':
         lastUpdated = substract(today(), reportingDays, 'days', 'l');
        return lastUpdated;
        case 'offlineDevicesByModelModal':
        case 'offlineDevicesBySiteModal':
           lastUpdated = substractStartDayCurrently(today(), reportingDays, 'hours', 'l');
          return lastUpdated;
      default:
        return '';
    }
  }

  return {
    downloadTableData
  }
}

export default useDetailsDownload
